import { useSearchContext } from "v4/contexts/SearchContext/SearchContext";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";

export default function useListingRowActionsRoute(identifierWithConditions = [], mustRouteBeVisible = false) {
    const { detailNavigation, getRouteByNativeIdentifier, isRouteVisibleByNativeIdentifier } = useNavigation();
    const { tab } = useSearchContext();
    const tabId = tab?.metadata?.tab_id;

    if (!tab?.native_identifier && tabId) {
        const flatDetailNav = detailNavigation.map(nav => [nav, ...(nav.children || [])]).flat();
        const detailNav = flatDetailNav.find(nav => nav.metadata.tab_id === tabId);

        if (detailNav) return detailNav;
    }

    const firstTabVisible = detailNavigation.find(nav => nav.label);

    const found = identifierWithConditions.find(r => r.condition);
    const identifier = found?.identifier;
    const isRouteVisible = isRouteVisibleByNativeIdentifier(identifier);

    if (!mustRouteBeVisible || isRouteVisible || !firstTabVisible) {
        return getRouteByNativeIdentifier(identifier);
    }

    return firstTabVisible;
}
